/**
 * Ryan O'Dowd
 * 2024-07-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import CPassage from '@classes/Passage';
import GoalProgress from '@components/GoalProgress';
import PassagePreview from './PassagePreview';
import PublicGoalPreview from '@containers/Discover/PublicGoalPreview';
import React from 'react';
import User from '@containers/Friends/User'; // @TODO: move this
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const SearchResult = (props: SearchResultProps) => {
  const styles = hooks.useStyles(getStyles);

  const passage = new CPassage(-1, props.item.translation_id, props.item.book_id, props.item.chapter_number, props.item.start_verse_number || props.item.verse_number, props.item.end_verse_number || props.item.verse_number || props.item.start_verse_number);

  return (
    // @TODO: show the highlighted text that matched the query (in every type of preview)
    // @TODO: show skeleton where relevant
    <View style={styles.container}>
      {props.sectionKey === 'goals' && (props.item.isPublic ? <PublicGoalPreview {...props.item} userCount={props.item.user_count} /> : <GoalProgress {...props.item} />)}{/* @TODO: add dense variant that just has single, unlabled progress ring to the left of text and no other rings below...should be much shorter */}
      {props.sectionKey === 'verseTexts' && <PassagePreview {...props.item} passage={passage} searchTerms={props.searchTerms} />}
      {props.sectionKey === 'friends' && <User {...props.item} isFollowing={props.item.isFollowing} />}{/* @TODO: isFollowing shouldn't have to be passed by parent */}{/* @TODO: dense=true? */}
      {/* @TODO: if user doesn't have whole translation downloaded, show message telling them search will be faster if they do; show button to download. (is this true? still want to search other translations anyways?) */}
      {/* @TODO: verse texts (with skeleton)...default to preferred translation but have option to search others */}
      {/* @TODO: new users to follow (with skeleton) */}
      {/* @TODO: help faqs */}
      {/* @TODO: settings? */}
    </View>
  );
};

class SearchResultProps {
  sectionKey: string;
  item: any;
  searchTerms: string[];
  searchText: string;
};

export default SearchResult;
